export const SHELL_MESSAGE_TYPES = [
    "bridge.ready", "session.refresh", "variant.select", "shell.chrome", "queue.enqueue",
    "collectCard", "cancelCard", "tenderCashOrder", "kickDrawer", "requestReprint",
    "bridge.hello", "session.state", "queue.state", "columns.pendingCash", "columns.working",
    "columns.online", "reader.state", "payment.result", "pi.connection",
];
//# sourceMappingURL=messages.js.map